var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "formRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c(
        "div",
        { staticClass: "bg-secondary-13 rounded py-3 px-4 mt-3" },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("div", { staticClass: "color-black font-14 my-1" }, [
                      _vm._v("Bitácora de Intervención:")
                    ]),
                    _c("custom-text-area", {
                      attrs: {
                        "count-classes": [
                          "d-block",
                          "small-counter",
                          "text-right"
                        ],
                        "custom-error-msg": "El comentario es requerido.",
                        error: errors[0],
                        maxlength: 3000,
                        placeholder: "Escribe un comentario",
                        "show-char-count": ""
                      },
                      model: {
                        value: _vm.model.comment,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "comment", $$v)
                        },
                        expression: "model.comment"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("div", { staticClass: "d-flex justify-content-between mt-4" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticClass: "file-input__container" },
                [
                  _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                    _vm._v(" Nombre del Documento: ")
                  ]),
                  _c("validation-provider", {
                    attrs: { rules: { required: !!_vm.model.file } },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg":
                                  "El nombre del documento es requerido",
                                error: errors[0]
                              },
                              model: {
                                value: _vm.model.fileAlias,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "fileAlias", $$v)
                                },
                                expression: "model.fileAlias"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "file-input__container" },
                [
                  _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                    _vm._v(" Archivo: ")
                  ]),
                  _c("validation-provider", {
                    attrs: { rules: { required: !!_vm.model.fileAlias } },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-file-input", {
                              attrs: {
                                accept: ".pdf",
                                "custom-error-msg": "El documento es requerido",
                                error: errors[0]
                              },
                              model: {
                                value: _vm.model.file,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "file", $$v)
                                },
                                expression: "model.file"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-end align-items-center mt-4"
              },
              [
                _c("action-button", {
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger mr-3 px-3"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                }),
                _c("action-button", {
                  attrs: {
                    i: "fas fa-save",
                    text: "Guardar",
                    variant: "success px-3"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }